<template>
    <b-card class="sa-card sa-paziente-progetti" header="Progetti" header-tag="header" footer-tag="footer" title="">
        <template #header>
            <div class="d-flex align-items-center justify-content-between">
                <h5 class="mt-0 mb-0">
                    <span>
                        <i class="fas fa-project-diagram"></i>
                        {{ titolo }}
                    </span>
                </h5>
                <b-button size="sm" variant="outline-success" @click="onClickAggiungiProgetto"> Aggiungi </b-button>
            </div>
        </template>

        <div class="sa-list-component">
            <div class="sa-list-component-header">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>{{ $i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>

            <div class="sa-list-component-body">
                <div class="sa-progetti-table-wrapper">
                    <b-table ref="table" stacked="lg" striped hover :items="progetti" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(nome)="{ item }">
                            {{ item.nomeProgetto }}
                        </template>
                        <template #cell(descrizione)="{ item }">
                            {{ item.descrizioneProgetto }}
                        </template>
                        <template #cell(dataInizio)="{ item }">
                            {{ formatDate(item.dataInizio) }}
                        </template>
                        <template #cell(dataFine)="{ item }">
                            {{ formatDate(item.dataFine) }}
                        </template>
                        <template #cell(actions)="{ item }">
                            <b-button size="sm" variant="btn btn-outline-secondary waves-effect waves-light width-sm no-text" @click="onClickViewProgetto(item)">
                                <font-awesome-icon icon="eye"></font-awesome-icon>
                            </b-button>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>

        <paziente-associa-progetto-modale ref="PazienteAssociaProgettoModale" :id-paziente="idPaziente" @change="onChangeAssociazioneProgetto"></paziente-associa-progetto-modale>
    </b-card>
</template>

<script>
import UtilityMixins from "../../utility/UtilityMixin";
import PazienteAssociaProgettoModale from "./PazienteAssociaProgettoModale.vue";

export default {
    mixins: [UtilityMixins],
    components: { PazienteAssociaProgettoModale },
    props: {
        idPaziente: String,
    },
    data() {
        return {
            pathResource: "/pazientiprogettianagrafica",
            filtroPazienteProgetti: {},
            progetti: [],
            rows: 0,
            perPage: 5,
            currentPage: 1,
            listKey: 0,
            fields: [
                {
                    label: "Nome Progetto",
                    key: "nomeProgetto",
                    sortable: true,
                },
                {
                    label: "Descrizione Progetto",
                    key: "descrizioneProgetto",
                    sortable: true,
                },
                {
                    label: "Data Inizio",
                    key: "dataInizio",
                    sortable: true,
                },
                {
                    label: "Data Fine",
                    key: "dataFine",
                    sortable: true,
                },
                {
                    class: "sa-table-column-action",
                    key: "actions",
                    label: "",
                },
            ],
        };
    },
    computed: {
        titolo() {
            return "Progetti";
        },
    },
    watch: {
        currentPage() {
            if (this.idPaziente) {
                this.loadDataProgetti(this.idPaziente);
            }
        },
    },
    mounted() {
        if (this.idPaziente) {
            this.loadDataProgetti(this.idPaziente);
        }
    },
    methods: {
        loadDataProgetti(idPaziente) {
            this.filtroPazienteProgetti = {
                idAnagrafica: idPaziente,
                page: this.currentPage,
                forPage: this.perPage,
            };
            this.loadDataResources(this.pathResource, this.filtroPazienteProgetti, this.loadDataProgettiSuccess, this.loadDataProgettiError);
        },
        loadDataProgettiSuccess(response) {
            let data = response.data.data.list;
            this.progetti = data ? data : [];
            this.rows = response.data.data.recordsNumber;
            this.listKey++;
        },
        loadDataProgettiError(error) {
            this.progetti = [];
            this.rows = 0;
            this.errorToast(error);
        },
        onClickViewProgetto(item) {
            let idProgetto = item.idProgetto;
            this.$router.push("/progettipazienti/view/" + idProgetto);
        },
        onClickAggiungiProgetto() {
            this.$refs.PazienteAssociaProgettoModale.show();
        },
        onChangeAssociazioneProgetto() {
            this.loadDataProgetti(this.idPaziente);
        },
    },
};
</script>

<style scoped>
.sa-paziente-progetti {
    margin-bottom: 0px;
}

.sa-paziente-progetti .card-header {
    padding-top: 0.35rem;
    padding-bottom: 0.35rem;
}

.sa-paziente-progetti .card-body {
    padding-top: 0.35rem;
    padding-bottom: 0.35rem;
}

.sa-paziente-progetti .sa-list-component-header p {
    margin-bottom: 0px;
}

.sa-paziente-progetti .sa-progetti-table-wrapper {
    overflow-x: auto;
}
</style>
